import { withStyles } from '@material-ui/core/styles'
import TableHead from '@material-ui/core/TableHead'

const CustomTableHead = withStyles(theme => ({
  root: {
    backgroundColor: '#DEDCD9'
  }
}))(TableHead)

export default CustomTableHead
